import {BrandPanels} from './BrandPanels';
import {CloudImage} from '~/modules/Common/components/CloudImage';
import {FC} from 'react';
import {Link} from '~/modules/Common/components/Link';
import {Panel} from './Panel';
import {ShoppingType} from '~/gql/generated';
import {Text} from '~/modules/Common/components/Text';
import {useExpertTheme} from '~/modules/Expert/hooks/useExpertTheme';
import {useProduct} from '../hooks/useProduct';

export const ProductDetail: FC = () => {
  const product = useProduct();
  const theme = useExpertTheme();

  if (!product) {
    return null;
  }

  const Image = theme.profile ? (
    <span className="block rounded-full overflow-hidden">
      <CloudImage
        alt="profile photo"
        width={30}
        height={30}
        src={`/profile/${theme.profile}`}
      />
    </span>
  ) : null;

  return (
    <>
      {product.description && (
        <Panel
          headline={
            <div className="flex flex-row flex-nowrap items-center gap-2">
              {Image}
              {theme.store?.productDescriptionHeadline ||
                `Why I love this product`}
            </div>
          }
          copy={product.description}
          isOpen={true}
          shouldTruncate={product.description.length > 500}
        />
      )}
      {(product.brand ||
        product.shoppingType === ShoppingType.Partial ||
        product.shoppingType === ShoppingType.FirstParty ||
        product.shoppingType === ShoppingType.Affiliate ||
        product.shoppingType === ShoppingType.Synthetic) && (
        <BrandPanels product={product} isFirstOpen={!product.description} />
      )}
      {product.shoppingType === ShoppingType.Partial && (
        <Text as="p" className="text-sm">
          Is this your brand?{' '}
          <Link to="/join" className={'underline'}>
            Integrate your products
          </Link>
        </Text>
      )}
    </>
  );
};
